module.exports = __webpack_public_path__ + "static/media/ranking.b15df652.svg";